import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';


import {clearSelection} from 'src/components/data-table-selection';
import {AccountSortField} from 'src/openapi/admin/models/AccountSortField';
import {SortDirection as SortDirections} from 'src/openapi/admin/models/SortDirection';

import {SortHeaderWithDataTable} from '@pb/kit-component-sort-header';

import {COLUMNS, HEADERS, SELECTION_KEY} from '../../constants';
import {useGetAccountSearchResultLicense} from '../../hooks/useGetAccountSearchResultLicense';
import {accountSearchResultStateActions, accountSearchResultStateSelector} from '../../slices/account-search-result-state.slice';
import {accountSearchResultResultSelector} from '../../slices/account-search-result.slice';

import {HeaderContentBefore} from './header-caption';
import {HeaderSkeleton} from './header-skeleton';

import type {SortDirection} from 'src/openapi/admin/models/SortDirection';

type Props = {
    accountIds: number[],
    totalCount: number,
};

const LicenseSeatsController = ({accountIds, totalCount}: Props) => {
    const dispatch = useDispatch();

    const cacheKeys = useSelector(accountSearchResultStateSelector);
    const {isLoading, loadingError} = useGetAccountSearchResultLicense({
        accountIds,
        totalCount,
        columnId: COLUMNS.LICENSE_SEATS,
    });

    const sort = useCallback((direction: ('ASC' | 'DESC')) => {
        dispatch(clearSelection(SELECTION_KEY));
        dispatch(accountSearchResultStateActions.setSortCriteria({
            direction: direction as SortDirection,
            field: AccountSortField.SEATS,
        }));
    }, [dispatch]);

    return (
        <SortHeaderWithDataTable
            defaultDirection={SortDirections.ASC}
            direction={cacheKeys.sortCriteria.field === AccountSortField.SEATS
                ? cacheKeys.sortCriteria.direction
                : null}
            filterActive={true}
            caption={HEADERS[COLUMNS.LICENSE_SEATS]}
            contentBefore={(isLoading || loadingError)
                ? <HeaderContentBefore isLoading={isLoading} loadingError={loadingError}/>
                : undefined}
            onSort={sort}
        />
    );
};

export const LicenseSeatsHeader = () => {
    const result = useSelector(accountSearchResultResultSelector);

    return result ? (
        <LicenseSeatsController
            accountIds={result.data.map(({accountId}) => accountId)}
            totalCount={result.totalCount}
        />
    ) : (
        <HeaderSkeleton columnId={COLUMNS.LICENSE_SEATS}/>
    );
};
